import { generateId } from "@/utils/generateId"

// This has to run FIRST
// set session id (used by liveupdate for example)
// a new one is created for each browser/tab refresh
sessionStorage.setItem("sessionId", generateId())
